import React, { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { archiveOrReadNotification } from "./../helperFunctions/readNotification";
import QueryDB from "@/api/queryDB/common";
import { createToast } from "./../../../utils/toaster/createToast";
import SingleNotificationActions from "./SingleNotificationActions";
import {
  notificationRoutes,
  showActionTypes,
} from "@/utils/constants/notificationVariables";
import { ErrorFallback } from "@/components";
import { typesToIgnore } from "../helperFunctions/notificationWithActions";
import { Avatar, Box, DropdownMenu, Flex, Text } from "@radix-ui/themes";

const SingleNotificationItem: React.FunctionComponent<{
  data: any;
  docId: string;
  whenWasSent: any;
}> = ({ data, docId, whenWasSent }) => {
  const [read, setRead] = useState<boolean>(data.read);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [toasted, hasToasted] = useState<boolean>(false);
  const [dataObj, setDataObj] = useState<any>(false);

  useEffect(() => {
    const fetch = async () => {
      const response = await QueryDB.getSingleDoc(
        showActionTypes[data.type]?.collection,
        data.contentId
      );
      if (response) {
        setDataObj(response);
      }
    };
    if (showActionTypes[data.type]) {
      fetch();
    }
  }, []);
  useEffect(() => {
    setRead(data.read);
  }, [data.read]);

  const readNotification = useCallback(async () => {
    if (!read) {
      if (typesToIgnore[data.type]) {
        return;
      }
      await archiveOrReadNotification(docId, true, false);
      setRead(true);
    }
  }, [read, data.type, data.notificationId]);

  if (
    !data.read &&
    !read &&
    !data.archived &&
    !toasted &&
    data.type === "message-recieved" &&
    window.location.pathname !== "/messages"
  ) {
    readNotification();
    hasToasted(true);
    createToast({
      type: "success",
      message: (
        <div
          onClick={() => {
            navigate(data.link);
          }}
        >
          {name} {data.content}
        </div>
      ),
    });
  }

  try {
    return (
      <DropdownMenu.Item
        color={!read ? "red" : "gray"}
        onClick={() => {
          if (!read && !showActionTypes[data.type]) {
            readNotification();
          }
        }}
      >
        <Flex gap="1" wrap="wrap" align="center">
          <Flex gap="1" wrap="wrap" align="center">
            <Avatar
              src={data.senderProfileLogoUrl}
              fallback={data.senderUsername.slice(0, 1)}
              size="1"
            />
            <Text size="1" color="gray">
              {data.senderUsername}
            </Text>
          </Flex>
          <Text
            size="1"
            color="gray"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
          <Text size="1" color="gray">
            {whenWasSent}
          </Text>
        </Flex>
        {/* {showActionTypes[data.type] && (
            <SingleNotificationActions
              read={read}
              setRead={setRead}
              data={data}
              docId={docId}
              dataObj={dataObj}
              setLoading={setLoading}
              loading={loading}
            />
          )} */}
      </DropdownMenu.Item>
    );
  } catch {
    <ErrorFallback> Error loading notification</ErrorFallback>;
  }
};

export default SingleNotificationItem;
